<template>
  <div>
    <div v-if="!editpage">
      <el-select filterable allow-create v-model="collection" @change="setcollection">
        <el-option v-for="x in cat" :key="x.value" :value="x.value" :label="x.label" placeholder="请选择数据库"></el-option>
      </el-select>

      <div>
        <el-input style="width: 7rem; margin-bottom: 1rem" placeholder="数据库命名" v-model="collectionlabel"></el-input>
      </div>
    </div>
    <br />

    <headerset v-if="refresh" ref="headerset" @headerseted="headerset"></headerset>

    <el-row>
      <el-button @click="ifjsondoc = !ifjsondoc" type="warning" plain>jsondoc和excel上传切换</el-button>
    </el-row>
    <jsondocinput v-if="ifjsondoc" @jsonkeys="jsonkeys" @jsondocdone="jsondocdone"></jsondocinput>
    <excelupload v-else @exceldone="exceldone"></excelupload>


    <div>
      <!--  v-if="headerconfig.fields.length > 0" -->
      <el-button type="primary" @click="tobeedits">
        将JSON填入页面编辑
      </el-button>
      <el-button style="margin-top:2em;width:50%" type="danger" @click="$message.error('双击重置数据库')"
        @dblclick.native="dbreset()">更新数据库</el-button>
    </div>
  </div>
</template>

<script>

import headerset from "./defineddb_headerset.vue";
import excelupload from "./defineddb_excel.vue"
import jsondocinput from "./defineddb_json.vue"

function getarr(objs, key) {
  let arr = [];
  objs.forEach((obj) => {
    arr.push(obj[key]);
  });
  return arr;
}

export default {
  components: { headerset, excelupload, jsondocinput },
  props: ["editpage"],
  data() {
    return {
      refresh: true,
      headerconfig: {
        fields: getarr(this.$store.state.currentheader, "name"),
        title: getarr(this.$store.state.currentheader, "title"),
        type: {
          date: [],
          number: []
        }
      },
      ifjsondoc: true,
      jsondoc: "[]",
      file: null,

      formdata: new FormData(),

      collection: this.editpage ? this.$store.state.collection.value : "",
      collectionlabel: this.editpage ? this.$store.state.collection.label : "",

    };
  },
  computed: {
    cat() {
      return this.$store.state.collections.filter(function (obj) {
        return obj.value.includes("tempexcel");
      });
    },
  },

  methods: {
    jsonkeys(keys) {
      this.$refs.headerset.titles = keys
    },
    jsondocdone(doc) {
      this.jsondoc = doc
      // console.log(doc)
    },
    headerset(hd) {
      this.headerconfig = hd
    },
    exceldone(file) {
      this.file = file
    },


    setcollection(val) {

      if (val != undefined) {
        this.$store.commit("reset");
        this.$axios.clctinitiate(val)
          .then(
            () => {
              this.refresh = false
              this.collectionlabel = this.$store.state.collection.label
              this.$nextTick(() => {
                this.refresh = true
              })

            }
          )
      }
    },

    tobeedits() {
      this.jsonset()
      let jsons = JSON.parse(this.jsondoc)
      jsons.forEach(obj => {
        this.$store.commit("setedits", obj)
      })
      this.jsondoc=""
    },

    //jsonset根据表头获取所需的json
    jsonset() {
      try {
        let doc = JSON.parse(this.jsondoc)
        if (!Array.isArray(doc)) {
          this.$message("json doc 需为Array格式，请检查")
        }
        else {
          //如果格式正确，那么只保留fields指定的key
          let fields = this.headerconfig.fields
          let newdoc = doc.map((obj, index) => {
            let newobj = {}
            fields.forEach(val => {
              newobj[val] = obj[val]
            })
            return newobj
          })

          this.jsondoc = JSON.stringify(newdoc)
        }
      }
      catch (e) {
        this.$message("json doc 格式错误");
        return;
      }
    },

    dbreset() {

      if (this.collection === "" || this.collectionlabel === "") {
        this.$message("你还未选择数据库");
        return;
      }
      if (this.headerconfig.fields.length == 0) {
        this.$message("请设置表头");
        return;
      }

      this.jsonset()

      if (this.collection != "" && !this.collection.includes("tempexcel")) {
        this.collection = "tempexcel_" + this.collection
      }

      let allconfig = {
        value: this.collection,
        label: this.collectionlabel,
        authcom: ["excel"]
      }

      Object.assign(allconfig, this.headerconfig)


      //json模式
      if (this.ifjsondoc) {
        this.$axios({
          method: "post",
          url: url + "jsontodb",
          data: { doc: this.jsondoc, allconfig: allconfig },
          config: { headers: { "Content-Type": "application/json" } },
        }).then((res) => {
          this.$message("提交成功");
          // this.dbfields = "";
          this.formdata = new FormData();
        });
      }
      //excel模式
      else {
        // console.log(allconfig)
        this.formdata.append("allconfig", JSON.stringify(allconfig))
        this.formdata.append("excel", this.file);
        this.$axios({
          method: "post",
          url: url + "exceltodb",
          data: this.formdata,
          config: { headers: { "Content-Type": "multipart/form-data" } },
        }).then((res) => {
          this.$message("上传成功");
          // this.dbfields = "";
          this.formdata = new FormData();
        });
      }


    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/exceltodb/defineddb.vue